import { isDefinedArray, isPositiveNumber, reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import {
  apiCallGetAllPromocodes,
  apiCallgetPromoCodeUsageHistory,
  apiCallUpdatePromoCode
} from "../../../api/auditor-api/api-call-promocode";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { TPromoCodes } from "../../../Types";
import { isValidReferralOrPromoCodeCode } from "../../../helpers/et3-data-helper";
import { TEt3PickerSingleValue, TRewardBenefitType } from "../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";

class PromoCodeStore {
  allPromocodesLimit = observable.box<TEt3PickerSingleValue>({
    label: "10",
    value: "10"
  });
  allPromocodes = observable.box<TPromoCodes>([]);

  promoCodeToUpdate = observable.box<string>("");
  promoCodeIDToUpdate = observable.box<number>(0);
  promoCodeIsActiveToUpdate = observable.box<TEt3PickerSingleValue>({
    label: "Active",
    value: "1"
  });

  promoCodeUsageHistory = observable.box<
    {
      user_id: number;
      isUserRewarded: string;
      rewardType: TRewardBenefitType;
      rewardAmountInHours: number;
      reason: string;
      created_on: string;
    }[]
  >([]);
  promoCodeHistory = observable.box<string>("");

  setAllPromoCodes = (data: TPromoCodes) => {
    runInAction(() => {
      this.allPromocodes.set(data);
    });
  };

  setAllPromocodesLimit = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.allPromocodesLimit.set(limit);
    });
  };

  setPromoCodeIsActiveToUpdate = (status: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.promoCodeIsActiveToUpdate.set(status);
    });
  };

  getAllPromocodes = async () => {
    const definedLimit = reducerToZeroIfUndefined(
      parseInt(this.allPromocodesLimit.get().value, 10)
    );
    if (!isPositiveNumber(definedLimit)) {
      return;
    }
    getCoreUIStore().setIsLoading("AUDITOR_PROMO_CODE", true);
    try {
      const result = await apiCallGetAllPromocodes(definedLimit);
      this.setAllPromoCodes(result.data);
      getCoreUIStore().setIsLoading("AUDITOR_PROMO_CODE", false);
    } catch (err) {
      getCoreUIStore().setIsLoading("AUDITOR_PROMO_CODE", false);
    }
  };
  updatePromoCode = async () => {
    const promoCodeToBeUpdated = this.allPromocodes
      .get()
      .filter((item) => item.promoCodeId === this.promoCodeIDToUpdate.get());
    const currentPromoCodeStatus = reduce(
      () => promoCodeToBeUpdated[0].isActive,
      0
    );
    if (
      `${currentPromoCodeStatus}` === this.promoCodeIsActiveToUpdate.get().value
    ) {
      getCorePopUpStore().showAlertMessage(
        "PROMO_STATUS_NOT_UPDATED_SUCCESSFULLY"
      );
      return;
    }

    const promoCodeIsActiveToUpdate = parseInt(
      this.promoCodeIsActiveToUpdate.get().value,
      10
    );

    getCoreUIStore().setIsLoading("AUDITOR_PROMO_CODE", true);
    try {
      const result = await apiCallUpdatePromoCode({
        promoCode: this.promoCodeToUpdate.get(),
        promoCodeId: this.promoCodeIDToUpdate.get(),
        isActive: promoCodeIsActiveToUpdate
      });
      const isCodeUpdated = reduce(() => result.data.promoCodeUpdated, false);
      await this.getAllPromocodes();
      if (isCodeUpdated) {
        getCorePopUpStore().showSuccessMessage(
          "PROMO_CODE_UPDATED_SUCCESSFULLY"
        );
      } else {
        getCorePopUpStore().showAlertMessage("PROMO_CODE_IS_NO_UPDATED");
      }
    } catch (err) {
      getCorePopUpStore().showAlertMessage("PROMO_CODE_IS_NO_UPDATED");
      getCoreUIStore().setIsLoading("AUDITOR_PROMO_CODE", false);
    }
  };
  getPromoCodeUsageHistory = async () => {
    const promoCodeValue = this.promoCodeHistory.get();
    if (!isValidReferralOrPromoCodeCode(promoCodeValue)) {
      getCorePopUpStore().showAlertMessage("INVALID_PROMO_CODE_KEY");
      return;
    }
    getCoreUIStore().setIsLoading("AUDITOR_PROMO_CODE", true);
    const { data, status, code } = await apiCallgetPromoCodeUsageHistory({
      promoCode: promoCodeValue
    });
    getCoreUIStore().setIsLoading("AUDITOR_PROMO_CODE", false);
    if (status === "OK") {
      const resultsArray = reduce(() => data, []);
      if (!isDefinedArray(resultsArray)) {
        getCorePopUpStore().showAlertMessage("NO_RESULT");
        return;
      }
      const newResultsArray = resultsArray.map((item) => {
        return {
          ...item,
          isUserRewarded: item.isUserRewarded ? "Yes" : "No"
        };
      });
      this.promoCodeUsageHistory.set(newResultsArray);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
    return;
  };

  getPromoCodesArrays = () => {
    return {
      allPromocodesArray: this.allPromocodes.get(),
      promoCodeUsageHistoryArray: this.promoCodeUsageHistory.get()
    };
  };
}
export const getPromoCodeStore = memoize(
  () => new PromoCodeStore(),
  () => 1
);
export default getPromoCodeStore;
